// PLUGINS IMPORTS //
import React from 'react'
import styled from 'styled-components/macro'

// COMPONENTS IMPORTS //
import SocialMediaSection from 'Content/Shared/Components/Sections/SocialMediaSection/SocialMediaSection'
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //
import {
  Themes,
  iPhoneResolution,
  iPadResolution,
} from 'Content/Shared/Styles/Theme'

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const Footer: React.FC<PropsType> = () => {
  return (
    <Wrapper>
      <Quote>Living, learning, & leveling up one day at a time.</Quote>

      <SocialMediaSection />
      <Footnote>
        Handcrafted by Artem Moshnin ©️{new Date().getFullYear()}
      </Footnote>
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const MARGIN_HORIZONTAL = '50px'
const MARGIN_VERTICAL = 50

const Wrapper = styled.div`
  background: #161920;
  position: relative;
  border: 1px solid #333036;
  border-right-width: 0px;
  border-left-width: 0px;
  border-bottom-width: 0px;

  padding: ${MARGIN_VERTICAL - 10}px ${MARGIN_HORIZONTAL} ${MARGIN_VERTICAL}px
    ${MARGIN_HORIZONTAL};
`

const Quote = styled.div`
  font-size: 30px;
  color: ${Themes.colors.primary};
  margin-top: 25px;
  margin-bottom: 50px;

  @media (max-width: ${iPadResolution}px) {
    font-size: 3.7vw;
  }

  @media (max-width: ${iPhoneResolution}px) {
    font-size: 6vw;
  }
`

const Footnote = styled.div`
  color: #8f9aa7;
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: 12px;
  margin-top: 60px;
  font-family: 'Nunito';

  @media (max-width: ${iPhoneResolution}px) {
    font-size: 10px;
  }
`

export default React.memo(Footer, memoComparison)
